import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css'],
})
export class ContactComponent {
  language!: string;
  constructor(private route: ActivatedRoute) {
    this.language = this.route.snapshot.url[0].path;
  }
}
